import { Store, select } from '@ngrx/store';
import * as fromCard from '../state/selectors';
var CardQuery = /** @class */ (function () {
    function CardQuery(store) {
        this.store = store;
    }
    Object.defineProperty(CardQuery.prototype, "values", {
        get: function () {
            return this.store.pipe(select(fromCard.getCards));
        },
        enumerable: true,
        configurable: true
    });
    return CardQuery;
}());
export { CardQuery };
